import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  endSessionTracking,
  resetSessionTracking,
  startSessionTracking,
  trackEvent,
} from "../../analytics/analyticsClient";

const AnalyticsBootstrap = () => {
  const location = useLocation();
  const sessionClosedRef = useRef(false);

  useEffect(() => {
    startSessionTracking();

    const handleSessionEnd = () => {
      if (sessionClosedRef.current) {
        return;
      }

      sessionClosedRef.current = true;
      endSessionTracking();
      resetSessionTracking();
    };

    window.addEventListener("pagehide", handleSessionEnd);
    window.addEventListener("beforeunload", handleSessionEnd);

    return () => {
      window.removeEventListener("pagehide", handleSessionEnd);
      window.removeEventListener("beforeunload", handleSessionEnd);
    };
  }, []);

  useEffect(() => {
    trackEvent("page_view", {
      pathname: location.pathname,
      search: location.search || "",
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsBootstrap;
